import consumer from "../channels/consumer"

let sharedSubscription = null
let sharedUserId = null
const listeners = new Set()
const connectionListeners = new Set()
let connected = false

function ensureSubscription(userId) {
    if (sharedSubscription && sharedUserId === userId) return sharedSubscription

    if (sharedSubscription) {
        sharedSubscription.unsubscribe()
        sharedSubscription = null
        connected = false
    }

    sharedUserId = userId
    sharedSubscription = consumer.subscriptions.create(
        { channel: "UserChannel", user_id: userId },
        {
            connected() {
                connected = true
                console.log(`✅ Connected to UserChannel #${userId}`)
                connectionListeners.forEach((listener) => listener())
            },

            disconnected() {
                connected = false
                console.log(`❌ Disconnected from UserChannel #${userId}`)
            },

            received(data) {
                listeners.forEach((listener) => {
                    try {
                        listener(data)
                    } catch (error) {
                        console.error("UserChannel listener failed", error)
                    }
                })
            },
        }
    )

    return sharedSubscription
}

export function createUserChannel(userId, onReceived, onConnected = null) {
    ensureSubscription(userId)
    if (onReceived) listeners.add(onReceived)
    if (onConnected) {
        connectionListeners.add(onConnected)
        if (connected) queueMicrotask(onConnected)
    }

    return {
        perform(action, data) {
            return sharedSubscription?.perform(action, data)
        },
        unsubscribe() {
            if (onReceived) listeners.delete(onReceived)
            if (onConnected) connectionListeners.delete(onConnected)

            if (listeners.size === 0 && sharedSubscription) {
                sharedSubscription.unsubscribe()
                sharedSubscription = null
                sharedUserId = null
                connected = false
            }
        }
    }
}
